import React from 'react';

const FlashlightFillIcon = ({ width, height, color }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24">
            <path d="M13 10H20L11 23V14H4L13 1V10Z" fill={color} />
        </svg>
    );
};

export default FlashlightFillIcon;
